import { InputBaseStateType, } from '@kubit/web-ui-components/inputBase/types';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
const pseudoElementsProps = (FOUNDATIONS, STATE_TOKENS) => ({
    focusVisible: {
        outline_style: 'none',
        box_shadow: 'none',
        ...STATE_TOKENS.focusVisible,
    },
    dataTruncate: {
        text_overflow: 'ellipsis',
        white_space: 'nowrap',
        overflow: 'hidden',
        ...STATE_TOKENS.dataTruncate,
    },
    passwordRevealButton: {
        display: 'none',
        ...STATE_TOKENS.passwordRevealButton,
    },
    webkitInnerSpinButton: {
        webkit_appearance: 'none',
        margin: '0',
        ...STATE_TOKENS.webkitInnerSpinButton,
    },
    webkitOuterSpinButton: {
        webkit_appearance: 'none',
        margin: '0',
        ...STATE_TOKENS.webkitOuterSpinButton,
    },
    placeholder: {
        font_weight: FONT_WEIGHT.font_regular,
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        color: FOUNDATIONS.color_comp_forms_input_empty_font,
        ...STATE_TOKENS.placeholder,
    },
});
const commonStateStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    input: {
        min_width: '0',
        cursor: 'pointer',
        opacity: '1',
        flex: '1',
        font_weight: FONT_WEIGHT.font_regular,
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
        text_align: 'left',
        ...pseudoElementsProps(FOUNDATIONS, { ...STATE_TOKENS.input }),
        ...STATE_TOKENS.input,
    },
});
const commonDisabledStateStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ...commonStateStyles(FOUNDATIONS, {
        input: {
            color: FOUNDATIONS.color_accent_disabled_font_50,
            cursor: 'not-allowed',
            placeholder: {
                color: FOUNDATIONS.color_accent_disabled_font_100,
            },
        },
        ...STATE_TOKENS,
    }),
});
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    [InputBaseStateType.FOCUSED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputBaseStateType.FOCUSED] }),
    },
    [InputBaseStateType.FILLED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputBaseStateType.FILLED] }),
    },
    [InputBaseStateType.EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputBaseStateType.EMPTY] }),
    },
    [InputBaseStateType.ERROR_EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputBaseStateType.ERROR_EMPTY] }),
    },
    [InputBaseStateType.ERROR_FILLED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputBaseStateType.ERROR_FILLED] }),
    },
    [InputBaseStateType.DISABLED_EMPTY]: {
        ...commonDisabledStateStyles(FOUNDATIONS, {
            ...STATE_TOKENS[InputBaseStateType.DISABLED_EMPTY],
        }),
    },
    [InputBaseStateType.DISABLED_FILLED]: {
        ...commonDisabledStateStyles(FOUNDATIONS, {
            ...STATE_TOKENS[InputBaseStateType.DISABLED_FILLED],
        }),
    },
});
//# sourceMappingURL=commonStyles.js.map